import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const NOTIF_LABELS = {
  new_episode:          (p) => `Episodio ${p?.episodeNumber} disponible`,
  completed_got_sequel: (p) => `Secuela: ${p?.sequelTitle || p?.animeTitle}`,
  new_anime_in_genre:   ()  => 'Nuevo en tus géneros',
  welcome:              ()  => '¡Bienvenido a Ashveil!',
  team_message:         ()  => 'Del equipo de Ashveil',
};

export default function FairyPanel({ fairyId, theme, notifications, currentLine, panelClass, position, onClose }) {
  const [recommendations, setRecommendations] = useState([]);
  const [loading,         setLoading]         = useState(true);
  const [pickLoading,     setPickLoading]     = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}/anime/recommendations`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((r) => r.json())
      .then((data) => {
        setRecommendations((data.results || []).slice(0, 5));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const goToAnime = (animeId) => {
    if (!animeId) return;
    navigate(`/anime/${animeId}`);
    onClose();
  };

  const handleFairyPick = async () => {
    if (pickLoading) return;
    setPickLoading(true);
    try {
      const res = await fetch(`${API_URL}/anime/fairy-picks`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const data = await res.json();
      const picks = data.results || [];
      if (picks.length > 0) {
        const pick = picks[Math.floor(Math.random() * picks.length)];
        if (pick?.id) {
          navigate(`/anime/${pick.id}`);
          onClose();
        }
      }
    } catch (err) {
      console.error('fairy pick error:', err);
    } finally {
      setPickLoading(false);
    }
  };

  const inlineStyle = {
    '--fairy-primary':   theme.primary,
    '--fairy-secondary': theme.secondary,
    '--fairy-glow':      theme.glow,
  };
  if (position === 'bottom-center' || position === 'top-center') {
    inlineStyle.left      = '50%';
    inlineStyle.transform = 'translateX(-50%)';
    inlineStyle.right     = 'unset';
  } else if (position?.endsWith('left')) {
    inlineStyle.left  = '2rem';
    inlineStyle.right = 'unset';
  } else {
    inlineStyle.right = '2rem';
    inlineStyle.left  = 'unset';
  }

  return (
    <div className={panelClass || 'fairy-panel fairy-panel--from-bottom'} style={inlineStyle}>
      <div className="fairy-panel-header">
        <span className="fairy-panel-name">{theme.name}</span>
        <button className="fairy-panel-close" onClick={onClose}>✕</button>
      </div>

      {currentLine && (
        <div className="fairy-panel-quote">{currentLine}</div>
      )}

      {notifications.filter((n) => n.type !== 'welcome' && n.type !== 'team_message').length > 0 && (
        <section className="fairy-panel-section">
          <h3 className="fairy-panel-title">Novedades</h3>
          <div className="fairy-notif-list">
            {notifications
              .filter((n) => n.type !== 'welcome' && n.type !== 'team_message')
              .slice(0, 5).map((notif, i) => {
              const p = notif.payload || {};
              const label = NOTIF_LABELS[notif.type]?.(p) || notif.type;
              const isMessage = notif.type === 'welcome' || notif.type === 'team_message';
              return (
                <div
                  key={i}
                  className="fairy-notif-row"
                  onClick={() => !isMessage && goToAnime(p.animeId)}
                  style={isMessage ? { cursor: 'default' } : undefined}
                >
                  {p.animeImage && (
                    <img
                      src={p.animeImage}
                      alt=""
                      className="fairy-notif-thumb"
                      referrerPolicy="no-referrer"
                    />
                  )}
                  <div className="fairy-notif-info">
                    {isMessage ? (
                      <>
                        <span className="fairy-notif-sub" style={{ fontStyle: 'normal', color: 'var(--fairy-primary)' }}>{label}</span>
                        <span className="fairy-notif-title" style={{ whiteSpace: 'normal', fontWeight: 400, fontSize: '0.78rem', color: '#ccd6f6' }}>{p.message}</span>
                      </>
                    ) : (
                      <>
                        <span className="fairy-notif-title">{p.animeTitle}</span>
                        <span className="fairy-notif-sub">{label}</span>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      )}

      <section className="fairy-panel-section">
        <h3 className="fairy-panel-title">Para vos</h3>
        {loading ? (
          <p className="fairy-loading">Buscando...</p>
        ) : recommendations.length === 0 ? (
          <p className="fairy-loading">Sin recomendaciones aún.</p>
        ) : (
          <div className="fairy-rec-list">
            {recommendations.map((anime) => (
              <div
                key={anime.id}
                className="fairy-rec-row"
                onClick={() => goToAnime(anime.id)}
              >
                {anime.image && (
                  <img
                    src={anime.image}
                    alt={anime.title}
                    className="fairy-rec-thumb"
                    referrerPolicy="no-referrer"
                  />
                )}
                <div className="fairy-rec-info">
                  <span className="fairy-rec-title">{anime.title}</span>
                  {anime.mal_score && (
                    <span className="fairy-rec-score">★ {anime.mal_score}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        <button
          className="fairy-pick-btn"
          onClick={handleFairyPick}
          disabled={pickLoading}
        >
          {pickLoading ? '...' : `¿Qué me recomendás vos, ${theme.name}?`}
        </button>
      </section>

    </div>
  );
}
